import type { TicketingRcaPayload } from '../pages/TicketingAnalytics/types';

export const TICKETING_RCA_MOCK: TicketingRcaPayload = {
	resolutionByRcaCategory: {
		title: 'Resolution by RCA Category',
		description: 'Total tickets attributed to each root cause category, largest to smallest',
		categories: [
			{ name: 'Software Bug', count: 265, percentage: 20.6 },
			{ name: 'Configurations', count: 262, percentage: 20.4 },
			{ name: 'User Error', count: 188, percentage: 14.6 },
			{ name: 'Knowledge Gap', count: 176, percentage: 13.7 },
			{ name: 'Enhancement Request', count: 170, percentage: 13.2 },
			{ name: 'Business Request', count: 161, percentage: 12.5 },
			{ name: 'Hardware Bug', count: 62, percentage: 4.8 },
		],
	},
	rcaByCategory: {
		title: 'RCA by Category',
		description:
			'Ticket concentration by RCA category and ticket category. Select a category column to drill into its sub-categories.',
		categories: ['System Issue', 'Access Request', 'Reporting', 'Training', 'System Enhancement', 'Hardware'],
		rcaCategories: [
			'Software Bug',
			'Hardware Bug',
			'Configurations',
			'Enhancement Request',
			'User Error',
			'Knowledge Gap',
			'Business Request',
		],
		matrix: [
			{
				rcaCategory: 'Software Bug',
				values: {
					'System Issue': 176,
					'Access Request': 19,
					Reporting: 56,
					Training: 0,
					'System Enhancement': 9,
					Hardware: 5,
				},
			},
			{
				rcaCategory: 'Hardware Bug',
				values: {
					'System Issue': 29,
					'Access Request': 0,
					Reporting: 0,
					Training: 0,
					'System Enhancement': 0,
					Hardware: 33,
				},
			},
			{
				rcaCategory: 'Configurations',
				values: {
					'System Issue': 88,
					'Access Request': 97,
					Reporting: 37,
					Training: 11,
					'System Enhancement': 18,
					Hardware: 11,
				},
			},
			{
				rcaCategory: 'Enhancement Request',
				values: {
					'System Issue': 29,
					'Access Request': 19,
					Reporting: 56,
					Training: 11,
					'System Enhancement': 55,
					Hardware: 0,
				},
			},
			{
				rcaCategory: 'User Error',
				values: {
					'System Issue': 58,
					'Access Request': 57,
					Reporting: 19,
					Training: 43,
					'System Enhancement': 0,
					Hardware: 11,
				},
			},
			{
				rcaCategory: 'Knowledge Gap',
				values: {
					'System Issue': 29,
					'Access Request': 38,
					Reporting: 19,
					Training: 76,
					'System Enhancement': 9,
					Hardware: 5,
				},
			},
			{
				rcaCategory: 'Business Request',
				values: {
					'System Issue': 29,
					'Access Request': 57,
					Reporting: 37,
					Training: 11,
					'System Enhancement': 27,
					Hardware: 0,
				},
			},
		],
	},
};

